import { RowWithIdentifier } from "../../_helpers/row-identifier";
import { DataTableRow } from "../../types";
import { BaseSubComponent } from "./base-sub-component";

interface DefaultTableSubComponentProps<TData extends RowWithIdentifier> {
  row: DataTableRow<TData>;
}

export function DefaultTableSubComponent<
  TData extends RowWithIdentifier & {
    v1Id?: string | number | null;
  },
>({ row }: DefaultTableSubComponentProps<TData>) {
  const { uuid, v1Id, createdAt, updatedAt } = row.original;
  return <BaseSubComponent uuid={uuid} v1Id={v1Id} createdAt={createdAt} updatedAt={updatedAt} />;
}
